<template>
  <div id="app">
    <Search @searchClicked="initSearch" ref="searchInput"/>
    <Help/>
    <div v-if="getLoading" class="loader"></div>
      <div v-if="isDataReady" class="song-container container-fluid mb-5 pl-5 row">
        <div class="col-md-6">
          <Song :videoSrc="getVideoSrc" id="song"/>
        </div>
        <div class="col-md-6 text-left">
          <Lyrics :lyricsText="getLyrics" @completed="showResults"/>
        </div>
      </div>
      <div v-else-if="getFailed">
        <div class="text-center py-5 container-fluid">
          <h1>
            Sorry, we weren't able to fetch details of that song. Maybe try a different one!?
          </h1>
        </div>
      </div>
      <div v-if="isResultReady">
        <Result :typingStats="getTypingStatsPassed"/>
      </div>
  </div>
</template>

<script>
import Search from "../components/Search.vue";
import Song from "../components/Song.vue";
import Lyrics from "../components/Lyrics.vue";
import Result from "../components/Result.vue";
import Help from "../components/Help.vue";

export default {
  name: "Home",
  components: {
    Search,
    Song,
    Lyrics,
    Result,
    Help
  },
  data: () => {
    return {
      lyricsApi: "https://music-typing.herokuapp.com/lyrics",
      youtubeApi: "AIzaSyDt8Vo1uIVl74oVexNfXtBGaUAOrrOdZCI",
      lyrics: String,
      isLoading: false,
      isReady: false,
      failed: false,
      resultReady: false,
      videoSrc: String,
      typingStatsPassed: Object,
    }
  },
  methods: {
    formatQuery(unformattedQuery) {
      return unformattedQuery.toLowerCase().replace(/ /g, "+");
    },
    initSearch(songEntered) {
      /**
       * Make the search and get the data using the API.
       * 
       * Once the data is fetched, call the child component
       * methods and updated the data there and after that
       * make the div visible.
       */
      this.isLoading = true;
      let actualQuery = songEntered
      songEntered = this.formatQuery(songEntered)
      let finalUrl = `${this.lyricsApi}?query=${songEntered}`
      fetch (finalUrl)
        .then(response => {return response.json()})
        .then(jsonData => {
          this.isLoading = false;
          if (jsonData["status"] != "OK") return false;
          this.lyrics = jsonData["lyrics"];
          this.getYoutubeVideo(actualQuery);
          return true
        })
        .then(status => this.failed = !status)
    },
    getYoutubeVideo(title) {
      // Get the youtube video by using the title from the
      // song search results.
      const Youtube = require("simple-youtube-api");
      const yt = new Youtube(this.youtubeApi);
      yt.searchVideos(title, 4)
        .then(results => {
          this.videoSrc = "https://www.youtube.com/embed/" + results[0]["id"]
        })
        .then(() => this.isReady = true)
    },
    showResults(typingStats) {
      /**
       * typingStats will be provided by the lyrics component.
       * 
       * This method will be only called when the user completes typing.
       */
      this.typingStatsPassed = typingStats;
      this.resultReady = true;
      this.isReady = false;
      // Clear the search text
      this.$refs.searchInput.eraseSongText();
    }
  },
  computed: {
    isDataReady() {
      return this.isReady;
    },
    getFailed() {
      return this.failed;
    },
    getVideoSrc() {
      return this.videoSrc;
    },
    getLyrics() {
      return this.lyrics;
    },
    getTypingStatsPassed() {
      return this.typingStatsPassed;
    },
    isResultReady() {
      return this.resultReady;
    },
    getLoading() {
      return this.isLoading;
    }
  }
};
</script>

<style lang="scss">
.song-container {
  #song {
    height: inherit;
  }
}
</style>